'use strict';

var React = require('react'),
    PureMixin = require('react-pure-render/mixin'),
    getThumURL = require('thum.io').getThumURL;

var ThumbnailGalleryItem = React.createClass({
	displayName: 'ThumbnailGalleryItem',

	propTypes: {
		url: React.PropTypes.string
	},

	mixins: [PureMixin],

	getInitialState: function getInitialState() {
		return {
			rerendered: false
		};
	},

	render: function render() {
		var url = this.props.url;
		var thumUrl = getThumURL({ maxAge: 12, width: 700, url: url });

		return React.createElement(
			'div',
			{ className: 'thumbnail-gallery-item col-sm-6 col-md-4 col-lg-3' },
			React.createElement(
				'div',
				{ className: 'thumbnail-gallery-image' },
				React.createElement('img', {
					src: thumUrl,
					onLoad: this.rerender,
					onError: this.rerender,
					alt: 'Preview of ' + url
				}),
				this.state.rerendered && React.createElement('img', {
					className: 'thumbnail-gallery-image-rerendered',
					src: thumUrl,
					alt: 'Preview of ' + url
				})
			)
		);
	},

	rerender: function rerender() {
		if (this.state.rerendered) {
			return;
		}

		this.setState({ rerendered: true });
	}
});

var ThumbnailGallery = React.createClass({
	displayName: 'ThumbnailGallery',

	getInitialState: function getInitialState() {
		return {
			nextUrl: 'http://www.msnbc.com/',
			urls: ['http://www.espn.com/', 'http://www.foxnews.com/', 'http://www.cnn.com/', 'http://www.msnbc.com/']
		};
	},

	render: function render() {
		return React.createElement(
			'div',
			{ className: 'thumbnail-gallery-container' },
			React.createElement(
				'form',
				{ className: 'row', onSubmit: this.addUrl },
				React.createElement(
					'div',
					{ className: 'form-group col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3' },
					React.createElement(
						'div',
						{ className: 'input-group hidden-xs' },
						React.createElement('input', {
							type: 'text',
							className: 'form-control homepage-input',
							id: 'testUrl',
							placeholder: 'URL to preview',
							onChange: this.updateNextUrl,
							value: this.state.nextUrl
						}),
						React.createElement(
							'span',
							{ className: 'input-group-btn' },
							React.createElement(
								'button',
								{ type: 'submit', className: 'btn btn-primary' },
								'See the difference'
							)
						)
					),
					React.createElement(
						'div',
						{ className: 'visible-xs' },
						React.createElement('input', {
							type: 'text',
							className: 'form-control homepage-input-phone',
							id: 'testUrl',
							placeholder: 'URL to preview',
							onChange: this.updateNextUrl,
							value: this.state.nextUrl
						}),
						React.createElement(
							'button',
							{ type: 'submit', className: 'btn btn-primary btn-block' },
							'See the difference'
						)
					)
				)
			),
			React.createElement('br', null),
			React.createElement(
				'div',
				{ className: 'row thumbnail-gallery' },
				this.state.urls.map(function (url, index) {
					return React.createElement(ThumbnailGalleryItem, { url: url, key: index + '-' + url });
				})
			)
		);
	},

	addUrl: function addUrl(e) {
		e.preventDefault();

		var nextUrl = this.state.nextUrl;
		if (nextUrl.indexOf('http') !== 0) {
			nextUrl = 'http://' + nextUrl;
		}

		this.setState({
			urls: [nextUrl].concat(this.state.urls.slice(0, 3))
		});
	},

	updateNextUrl: function updateNextUrl(e) {
		var nextUrl = e.target.value;
		this.setState({ nextUrl: nextUrl });
	}
});

module.exports = ThumbnailGallery;


//////////////////
// WEBPACK FOOTER
// ./client/components/ThumbnailGallery.js
// module id = 441
// module chunks = 0